export default __webpack_public_path__ + "static/media/workDay.4e6eb585.PNG";